import { nextTick } from 'vue'

/**
 * Composable for managing prerender.io meta tags and page readiness
 * @returns {Object} Prerender utility functions
 */
export default function usePrerender() {
  /**
   * Sets the prerender-status-code meta tag
   * @param {number} code - HTTP status code to set (e.g. 200, 404)
   */
  const setPrerenderStatusCode = (code) => {
    let meta = document.querySelector('meta[name="prerender-status-code"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'prerender-status-code'
      document.head.appendChild(meta)
    }
    meta.content = code
  }

  /**
   * Marks the page as ready for prerendering
   * Should be called when all async content is loaded
   * @returns {Promise<void>} Resolves after next tick when ready state is set
   */
  const setPageReady = async () => {
    await nextTick()
    window.prerenderReady = true
  }

  return {
    setPrerenderStatusCode,
    setPageReady
  }
}
